module.exports = __webpack_public_path__ + "static/img/y28.ed1df17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y28.jpg
// module id = CM4i
// module chunks = 1